import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'

import Center from '../../../packages/kiti/components/helpers/Center'
import IconBlock from '../../../components/presentation/IconBlock'
import useOAuthLoginRequest from '../google/_request/loginRequest'

const AuthFromAdmin = ({ sessionReference }) => {
  const { t } = useTranslation('session')
  const [handleRequest] = useOAuthLoginRequest(sessionReference)

  useEffect(() => {
    handleRequest()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Center flex={1} minHeight="100vh">
        <IconBlock icon="RiLoginBoxLine" title={t('authFromAdmin.title')} subtitle={t('authFromAdmin.subtitle')} />
      </Center>
    </div>
  )
}

export default AuthFromAdmin
